"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryClient = exports.createPrefetch = exports.useQueryClient = exports.usePrefetchAttachedIds = exports.usePrefetch = exports.Prefetch = void 0;
const react_1 = __importDefault(require("react"));
const object_hash_1 = __importDefault(require("object-hash"));
const react_query_1 = require("@tanstack/react-query");
const PrefetchContext = react_1.default.createContext(false);
class PrefetchStore {
    constructor() {
        this.pathname = "";
        this.queries = {};
        this.fulfilledQueries = {};
        this.fulfilledDependents = {};
        this.modelTrack = {};
        if (typeof window !== "undefined") {
            const foundById = document.getElementById('qStore');
            if (foundById) {
                const parsed = JSON.parse(foundById.textContent);
                this.fulfilledDependents = parsed.fulfilledDependents;
                this.fulfilledQueries = parsed.fulfilledQueries;
                this.queries = parsed.queries;
            }
        }
    }
    queue(props, modelTrack) {
        this.queries[(0, object_hash_1.default)(props)] = props;
        this.modelTrack = modelTrack;
        if (this.fulfilledQueries[(0, object_hash_1.default)(props)]) {
            return this.fulfilledQueries[(0, object_hash_1.default)(props)];
        }
    }
    reportPathName(name) {
        this.pathname = name;
    }
}
const queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 60 * 0.25,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
        },
    },
});
exports.queryClient = queryClient;
const Prefetch = ({ provider, children }) => {
    const [firstRun, setFirstRun] = react_1.default.useState(true);
    if (firstRun) {
        Object.entries(provider.fulfilledQueries).forEach(([hash, data]) => {
            const queryArgs = provider.queries[hash];
            queryClient.setQueryData([JSON.stringify(queryArgs)], {
                pageParams: [1],
                pages: [data]
            });
        });
        Object.entries(provider.fulfilledDependents).forEach(([id, data]) => {
            queryClient.setQueryData(['scoped-id', id], data);
        });
    }
    react_1.default.useEffect(() => {
        setFirstRun(false);
    }, []);
    const maybe = react_1.default.useCallback((props, modelTrack) => {
        return provider.queue(props, modelTrack);
    }, []);
    const value = react_1.default.useMemo(() => ({
        maybe,
        provider,
        queryClient
    }), [maybe]);
    return (react_1.default.createElement(PrefetchContext.Provider, { value: value },
        react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient }, children)));
};
exports.Prefetch = Prefetch;
const usePrefetch = (props, modelTrack) => {
    const ctx = react_1.default.useContext(PrefetchContext);
    if (ctx) {
        return ctx.maybe(props, modelTrack);
    }
    return null;
};
exports.usePrefetch = usePrefetch;
const usePrefetchAttachedIds = (props, modelTrack) => {
    const ctx = react_1.default.useContext(PrefetchContext);
    if (ctx) {
        const existingMaybe = ctx.maybe(props, modelTrack);
        if (existingMaybe) {
            return existingMaybe.ids.reduce((acc, val) => {
                const r = ctx.provider.fulfilledDependents[val];
                if (r) {
                    return {
                        ...acc,
                        [val]: [r]
                    };
                }
                return acc;
            }, {});
        }
    }
    return {};
};
exports.usePrefetchAttachedIds = usePrefetchAttachedIds;
const useQueryClient = () => {
    const ctx = react_1.default.useContext(PrefetchContext);
    if (ctx) {
        return ctx.queryClient;
    }
    return null;
};
exports.useQueryClient = useQueryClient;
const createPrefetch = () => new PrefetchStore();
exports.createPrefetch = createPrefetch;
//# sourceMappingURL=prefetcher.js.map